import Swiper, { Navigation, Pagination } from 'swiper';
import { DateTime } from "luxon";
import Noty from 'noty'

const event = {
    /**
     * Component for events frequently asked questions
     */
    frequentlyAskedQuestions() {
        /**
         * Find the element for the components
         */
        document.querySelectorAll('[data-component="frequently-asked-questions"]').forEach((component) => {
            component.querySelectorAll('a[data-toggle="collapse"]').forEach((question) => {
                question.addEventListener('click', (event) => {
                    /**
                     * Prevent the default behavior
                     */
                    event.preventDefault();

                    /**
                     * Toggle the content for the question
                     */
                    if (component.querySelector(question.getAttribute('href'))) {
                        let content = component.querySelector(question.getAttribute('href'));

                        /**
                         * Toggle the state for the content
                         */
                        content.classList.toggle('show');

                        /**
                         * Find the answers in the component and deactivate them
                         */
                        component.querySelectorAll('.question-answer').forEach((answer) => {
                            if (answer != content) {
                                answer.classList.remove('show');
                            }
                        });
                    }
                });
            });
        });
    },
    /**
     * Component for event contact form input validation
     * @param {} input
     * @returns
     */
    contactFormValidation(input) {

        return function(e) {
            let inputName = input.getAttribute('name');
            let errorMessage = document.createElement('span');
            errorMessage.setAttribute('class', 'input-error');
            errorMessage.textContent = 'This value is required';
            let inputParent = input.parentElement;

            //should contain letterss digits and '-'
            const pattern = /[a-zA-Z\d-]/g;

            if (input.value.trim() == '') {
                if (inputParent.querySelector('.input-error')) {
                    inputParent.querySelector('.input-error').textContent = 'This field is required';
                }

                if (!inputParent.classList.contains('error')) {
                    inputParent.classList.add('error');
                    inputParent.appendChild(errorMessage);
                }

                return false;
            }

            if (inputName == 'email') {
                if (!input.value.includes('@') || !input.value.includes('.')) {

                    if (inputParent.querySelector('.input-error')) {
                        inputParent.querySelector('.input-error').textContent = 'Please enter valid email';
                    }

                    if (!inputParent.classList.contains('error')) {
                        inputParent.classList.add('error');
                        errorMessage.textContent = 'Please enter valid email';
                        inputParent.appendChild(errorMessage);
                    }
                    return false;
                }

            } else if (!pattern.test(input.value)) {

                if (inputParent.querySelector('.input-error')) {
                    inputParent.querySelector('.input-error').textContent = 'It should contain only letters, numbers and "-" ';
                }

                if (!inputParent.classList.contains('error')) {
                    inputParent.classList.add('error');
                    errorMessage.textContent = 'It should contain only letters, numbers and "-" ';
                    inputParent.appendChild(errorMessage);
                }

                return false;
            }

            inputParent.classList.remove('error');
            let errorSpan = (input.parentElement).querySelector('.input-error');

            if (errorSpan) {
                input.parentElement.removeChild(errorSpan);
            }

            return true
        }
    },
    /**
     * Component for the event contact form
     * @returns
     */
    contactUs() {
        const form = document.getElementById('contact-form');

        if (!form) {
            return
        }
        const thankYou = document.querySelector('.thank-you');
        const errorBlock = document.querySelector('.error-box');
        const submitBtn = form.querySelector('.submit');
        const event = this;

        const formFields = {
            eventId: form.querySelector('.event'),
            name: form.querySelector('[name="name"]'),
            email: form.querySelector('[name="email"]'),
            message: form.querySelector('[name="message"]')
        }

        Object.keys(formFields).forEach(key => {
            if (key !== 'eventId') {
                formFields[key].addEventListener('blur', event.contactFormValidation(formFields[key]));
            }
        });

        submitBtn.addEventListener('click', function(e) {
            e.preventDefault();

            const data = {
                "event_id": formFields.eventId.value,
                "name": formFields.name.value,
                "email": formFields.email.value,
                "message": formFields.message.value,
                "g-recaptcha-response": grecaptcha.getResponse()
            }

            // Validation on submit
            let flag = false;
            Object.keys(formFields).forEach(key => {
                if (key !== 'eventId') {
                    event.contactFormValidation(formFields[key])() === false ? flag = true : '';
                }
            });
            if (grecaptcha.getResponse() === '') {
                document.querySelector('.g-recaptcha iframe').style.border = '1px solid red';
                return
            }

            if (flag) return;

            fetch('/events/city/email', {
                    method: 'POST',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(data)
                })
                .then(response => response.json())
                .then(result => {

                    if (result.status === 'SUCCESS') {
                        form.style.display = 'none';
                        thankYou.style.display = 'block';
                    }
                    if (result.status === 'ERROR') {
                        form.style.display = 'none';
                        errorBlock.style.display = 'block';
                    }
                    formFields.name.value = '';
                    formFields.email.value = '';
                    formFields.message.value = '';

                })
                .catch(error => console.log(error))

        })

    },
    /**
     * Component for the event contact form thankyou message
     */
    closeThankYou() {
        const contactForm = document.querySelector('#contact-form');
        const closeBtns = Array.from(document.querySelectorAll('.close-response-handle'));

        closeBtns.forEach(btn => {
            btn.addEventListener('click', function(e) {
                document.querySelector(btn.dataset.parent).style.display = 'none';
                contactForm.style.display = 'block';
            })
        })
    },
    /**
     * Component for the event contact form error handler
     * @returns
     */
    handleError() {
        const errorBlock = document.querySelector('.error-box');

        if (!errorBlock) {
            return
        }
        const contactForm = document.querySelector('#contact-form');
        const tryAgainBtn = errorBlock.querySelector('.try-again');
        tryAgainBtn.addEventListener('click', function(e) {
            errorBlock.style.display = 'none';
            contactForm.style.display = 'block';
        })
    },
    /**
     * Component for the events participating schools, partners and testimonials
     * @param {*} selector
     */
    initSlider(selector) {
        const sliderSchools = new Swiper('.swiper-schools', {
            modules: [Navigation, Pagination],
            speed: 400,
            // enabled: false,
            // noSwiping: true,
            slidesPerView: 2,
            spaceBetween: 10,
            loop: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            // Responsive breakpoints
            breakpoints: {
                // when window width is >= 600px
                600: {
                    slidesPerView: 3,
                    spaceBetween: 20
                },
                768: {
                    slidesPerView: 4,
                    spaceBetween: 20
                },
                1000: {
                    slidesPerView: 5,
                    spaceBetween: 20
                },
                1200: {
                    slidesPerView: 6,
                    spaceBetween: 30
                },
            }

        });

        const sliderPArtners = new Swiper('.swiper-partners', {
            modules: [Navigation, Pagination],
            speed: 400,
            // enabled: true,
            // noSwiping: true,
            slidesPerView: 2,
            spaceBetween: 10,
            loop: true,
            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            // Responsive breakpoints
            breakpoints: {
                // when window width is >= 600px
                600: {
                    slidesPerView: 3,
                    spaceBetween: 20
                },
                768: {
                    slidesPerView: 4,
                    spaceBetween: 20
                },
                1000: {
                    slidesPerView: 5,
                    spaceBetween: 20
                },
                1200: {
                    slidesPerView: 6,
                    spaceBetween: 30
                },
            }
        })

        const sliderTestimonials = new Swiper('.testemonials-wrapper', {
            modules: [Navigation, Pagination],
            speed: 400,
            // enabled: true,
            // noSwiping: true,
            slidesPerView: 1,
            spaceBetween: 10,
            loop: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                clickableClass: '.swiper-pagination-bullet-click',
            },
            // Responsive breakpoints
            breakpoints: {
                // when window width is >= 650px
                650: {
                    slidesPerView: 2,
                    spaceBetween: 20
                }
            }
        })
    },
    /**
     * Component for the events available seats counter
     * @returns
     */
    seatsCounter() {
        const dateEl = document.querySelector('#heading .date');

        if (!dateEl) {
            return
        }
        const seatsEl = document.querySelector('#heading .seats');
        const typeOfEvent = document.querySelector('#heading .info .type');

        let seats;
        const eventDate = DateTime.fromISO(`${dateEl.dataset.date}T${ dateEl.dataset.time}`, { zone: 'UTC' });
        let daysFromNow = eventDate.diffNow(['days']).days.toFixed(0);

        if (daysFromNow <= 21 && daysFromNow >= 0) {

            daysFromNow <= 13 ? seats = 2 : seats = daysFromNow - 11;

            seatsEl.querySelector('.num').textContent = seats;
            seatsEl.style.display = 'flex';
            //typeOfEvent.style.marginRight = '80px';
        }

    },
    /**
     * Compoenent for the candidates schools preferences when registering for events
     */
    CandidatesSchoolsPreferences() {
        /**
         * Find the element for the components
         */
        document.querySelectorAll('[data-component="candidates-schools-preferences"]').forEach((component) => {
            let form = component.querySelector('form');

            /**
             * Verify that we have the form element in the component
             */
            if (!form) {
                return false;
            }

            /**
             * Find the elements in the component
             */
            form.querySelectorAll('[data-element="school"]').forEach((element) => {
                /**
                 * Verify that the trigger does not have the event already
                 */
                if (element.hasAttribute('data-event-candidates-schools-preferences-choice')) {
                    return false;
                }

                /**
                 * Mark the element with custom attribute that we have attached an event
                 */
                element.setAttribute('data-event-candidates-schools-preferences-choice', true);

                /**
                 * Attach to the element change event to handle the update
                 */
                element.addEventListener('change', () => {
                    let choices = form.querySelectorAll('[data-element="school"]:checked').length;

                    /**
                     * Reset the state for the checkbox when we reached the limit
                     */
                    if (choices > 3) {
                        element.checked = false;
                        element.removeAttribute('checked');
                    }
                });
            });

            /**
             * Attach to the form event and handle the process
             */
            form.addEventListener('submit', (event) => {
                event.preventDefault();

                /**
                 * Get the amount of selected schools
                 */
                let choices = form.querySelectorAll('[data-element="school"]:checked').length;

                /**
                 * Verify that we have choices made by the user
                 */
                if (!choices) {
                    return false;
                }

                /**
                 * Create the form data object for the action
                 */
                const body = new FormData();
                body.append('user', form.querySelector('[name="user"]').value);
                body.append('product', form.querySelector('[name="product"]').value);

                /**
                 * Collect the schools from the form
                 */
                form.querySelectorAll('[data-element="school"]:checked').forEach((checkbox) => {
                    body.append('schools[]', checkbox.value);
                });

                /**
                 * Submit the information to the endpoint
                 */
                fetch(form.getAttribute('action'), {
                    method: 'POST',
                    mode: "cors",
                    credentials: "same-origin",
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                    body: body
                })
                .then(response => response.json())
                .then(result => {
                    new Noty({
                        type: 'success',
                        layout: 'top',
                        timeout: 10000,
                        text: 'Thank you. Your preferences were sent to our team successfully.',
                    }).show();
                })
                .catch(error => console.log(error));
            });
        });
    },
}

export default event
